import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Download, Printer, Share2, Pencil, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, API } from "@/lib/api";
import { ProposalDocument } from "@/components/ProposalDocument";

export default function ProposalPreviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [s, setS] = useState({});

  useEffect(() => {
    Promise.all([api.get(`/proposals/${id}`), api.get("/settings")])
      .then(([pr, se]) => { setP(pr.data); setS(se.data); })
      .catch(() => toast.error("Could not load proposal"));
  }, [id]);

  const share = () => {
    navigator.clipboard.writeText(`${window.location.origin}/proposal/${p.share_id}`);
    toast.success("Share link copied");
  };

  if (!p) return <div className="min-h-screen flex items-center justify-center text-muted-foreground"><Loader2 className="animate-spin mr-2" /> Loading…</div>;

  return (
    <div className="min-h-screen bg-onyx-charcoal py-8">
      <div className="max-w-[900px] mx-auto px-4 flex items-center justify-between mb-6 no-print">
        <button onClick={() => navigate("/admin/proposals")} className="text-white/60 hover:text-white flex items-center gap-2 text-sm"><ArrowLeft size={16} /> Proposals</button>
        <div className="flex gap-2">
          <Link to={`/admin/proposals/${id}/edit`} data-testid="preview-edit" className="flex items-center gap-2 border border-white/30 text-white px-4 py-2.5 text-[11px] tracking-[0.1em] uppercase hover:bg-white/10 transition-colors"><Pencil size={14} /> Edit</Link>
          <button onClick={share} data-testid="preview-share" className="flex items-center gap-2 border border-white/30 text-white px-4 py-2.5 text-[11px] tracking-[0.1em] uppercase hover:bg-white/10 transition-colors"><Share2 size={14} /> Share</button>
          <button onClick={() => window.print()} data-testid="preview-print" className="flex items-center gap-2 border border-white/30 text-white px-4 py-2.5 text-[11px] tracking-[0.1em] uppercase hover:bg-white/10 transition-colors"><Printer size={14} /> Print</button>
          <a href={`${API}/proposals/${id}/pdf`} data-testid="preview-pdf" className="flex items-center gap-2 bg-white text-onyx-black px-4 py-2.5 text-[11px] tracking-[0.1em] uppercase hover:bg-onyx-wood transition-colors"><Download size={14} /> PDF</a>
        </div>
      </div>
      <div className="shadow-2xl"><ProposalDocument proposal={p} settings={s} /></div>
    </div>
  );
}
